export const BOOTSTRAP_BREAKPOINTS = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
export const BREAKPOINT_ORDER = ["sm", "md", "lg", "xl"];
